import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

// Get change log for current version +
export const getChangeLogForCurrentVersion = createAsyncThunk(
  "changeLog/getChangeLogForCurrentVersion",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/changelog/current`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Mark current version changes as read +
export const markCurrentVersionChangesAsRead = createAsyncThunk(
  "changeLog/markCurrentVersionChangesAsRead",
  async (id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/changelog/${id}/read`
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);
